import { Component, OnDestroy, ViewChild, TemplateRef, OnInit } from '@angular/core';
import { NavigationService } from '@services/support/navigation.service';
import { Subscription } from 'rxjs';
import { DetailPageService } from '@services/support/detail-page.service';
import { AuthService } from '@services/auth.service';
import { FlashMessagesService } from '@mobilestar/ngx-flash-messages';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, OnDestroy {

  @ViewChild("licenseTemplate", { static: false }) private licenseTemplate: TemplateRef<any>;

  sidebarOpen: boolean = false;
  sidebarSub: Subscription = null;

  loginTimeout: number = 0;
  loginCounter: any;

  onlyDownloads = environment.onlyDownloads

  constructor(
    private authService: AuthService,
    private navigationService: NavigationService,
    private detailPageService: DetailPageService,
    private flashMessages: FlashMessagesService
  ) {
    this.sidebarSub = this.navigationService.sidebarState.subscribe(state => {
      this.sidebarOpen = state;
    });
  }

  ngOnInit() {
    if (!this.onlyDownloads) {
      this.startSessionExpireTimer();
    }
  }

  async startSessionExpireTimer() {
    const offset = await (this.authService.getServerTimeOffset().catch(error => 0));
    this.loginCounter = setInterval(() => {
      if (this.authService.currentUser) {
        const expire = this.authService.currentUser.expire - Date.now() - offset;
        if (expire > 0) {
          this.loginTimeout = expire;
        } else {
          this.onLoginExpire();
        }
      } else {
        this.onLoginExpire();
      }
    }, 1000);
  }

  onLoginExpire() {
    this.authService.logout();
    this.flashMessages.show("Your session has expired.", { cssClass: 'alert-danger', timeout: 999000, closeOnClick: true });
    if (this.loginCounter) {
      clearInterval(this.loginCounter);
      this.loginCounter = null;
    }
  }

  toggleSidebar() {
    this.navigationService.toggleSidebar();
  }

  onSidebarLinkClicked() {
    // Toggle sidebar if width is smaller than 768px
    if (window.innerWidth < 768) {
      this.navigationService.toggleSidebar();
    }
    this.detailPageService.removeComponent();
  }

  ngOnDestroy() {
    if (this.sidebarSub) { this.sidebarSub.unsubscribe() }
    if (this.loginCounter) { clearInterval(this.loginCounter) }
  }
}
